<template>
  <div class="right-nav">
    <div class="shopping-cart" v-if="isShoppingOpen " @click="toOpenGoodList"></div>
    <div class="like-btn-box">
        <canvas id="thumsCanvas" width="100" height="240" style="width:50px;height:120px" class="canvas"></canvas>
        <span class="like-num">{{ zanNumber }}</span>
        <figure class="like-btn" @click="toLike">
          <img src="../assets/like.png" alt="">
        </figure>
    </div>
  </div>
</template>
<script>
import { ThumbsUpAni } from '../plugins/like-animation'
export default {
  props: {
    zanNumber: {
      type: Number,
      default: 0
    },
    isShoppingOpen: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    thumbsUpAni: null
  }),
  components: {
  },
  created () {
  },
  mounted () {
    this.thumbsUpAni = new ThumbsUpAni()
  },
  methods: {
    showLikeAnimation () {
      setTimeout(() => {
        this.thumbsUpAni.start()
      }, 300)
    },
    toLike () {
      this.$emit('toLike')
    },
    toOpenGoodList () {
      this.$emit('openGoodList')
    }
  }
}
</script>
<style lang="less" scoped>
.right-nav {
  position: fixed;
  bottom: 70px;
  right: 16px;
  z-index: 200;

  .shopping-cart {
    width: 40px;
    height: 40px;
    margin-bottom: 20px;
    background-image: url("https://s.kcimg.cn/live/image/shopping_cart_icon.png");
    background-size: 100%;
    cursor: pointer;
    pointer-events: auto;
  }

  .like-btn-box {
    position: relative;
     width: 40px;
     height: 40px;
    .canvas {
      position: absolute;
      bottom: 40px;
      left: -5px;
      pointer-events: none;
      /*background: #fff;*/
    }

    .like-num {
      position: absolute;
      top: -10px;
      left: 50%;
      transform: translateX(-50%);
      display: inline-block;
      margin: 0 auto;
      padding: 0 6px;
      height: 14px;
      background: #FFFFFF;
      border-radius: 7px;
      cursor: pointer;
      line-height: 14px;
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      color: #FD3D7F;
    }

    .like-btn {
      /*position: absolute;*/
      display: block;
      width: 40px;
      height: 40px;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media screen and (min-width: 751px) {
  .right-nav {
    left: 50%;
    margin-left: 300px;

    .like-btn-box {
      .like-num {
        left: 20px;
      }
    }
  }
}</style>
